<template>
  <div id="inflammation">
    <InnerContent>
      <ContentHeader title="Early Inflammation Activity"/>

      <transition name="fade" appear>
        <div class="video-container">
          <video poster="@/assets/img/video-thumbnail-inflammatiom.jpg"
          controls 
          playsinline
          disablePictureInPicture
          controlslist="nodownload" 
          id="videoElement" 
          @canplay="updatePaused" 
          @playing="updatePaused" 
          @pause="updatePaused">
            <source src="@/assets/videos/onset-animation.mp4" type="video/mp4">
          </video>
          <div class="play-icon-container" v-show="paused" @click="play">
            <img src="@/assets/img/icon-play-white.svg" alt="">
          </div>
        </div>
      </transition>
      <div class="text-container">
        <p>Early inflammation in MS can disrupt the blood-brain barrier (BBB) that normally protects the brain. This leakage of the BBB allows autoreactive B&nbsp;cells and T&nbsp;cells to enter the central nervous system (CNS) and attack myelin and other CNS structures.<sup>1</sup></p>
      </div>
    </InnerContent>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader';

export default {
  name: 'Inflammation',
  components: {
    ContentHeader
  },
  data() {
    return {
      videoElement: null,
      paused: null
    }
  },
  computed: {
    playing() { return !this.paused; }
  },
  methods: {
    updatePaused(event) {
      this.videoElement = event.target;
      this.paused = event.target.paused;
    },
    play() {
      this.videoElement.play();
    },
    pause() {
      this.videoElement.pause();
    }
  }
}
</script>

<style lang="scss" scoped>
  #inflammation {
    width: 100%;
		position: relative;
    background: $blue-dark;

    .inner-content {
      padding-bottom: 20px;
    }
  }

  .content-background {
		background-color: $blue-dark;
  }

  .video-container {
    width: 100%;
    display: block;
    margin: 0 auto;
    position: relative;
    transition: all .3s .3s ease;

    video {
      width: 100%;
    }
    .play-icon-container {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 10%;
      transform: translate(-50%, -50%);
      img {
        width: 100%;
      }
    }
  }

  .text-container {
    width: 100%;
    margin: 0 auto;
    padding: 20px 0;
    color: $white;

    p {
      font-size: rem(18px);
      line-height: rem(24px);
      margin-bottom: 10px;
    }
  }

  // Transitions
  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity .3s .3s;
  }

  .fade-leave-active {
    opacity: 0;
  }
</style>
